import React from "react";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { RadarChart, Radar, PolarAngleAxis, PolarGrid } from "recharts";
import { DP22, minFixedDecimal } from "@/helpers/helperFunctions";
import clsx from "clsx";

type ProfileRadarChartProps = {
  data: { name: string; value: number }[];
  className?: string;
};

const ProfileRadarChart: React.FC<ProfileRadarChartProps> = ({
  data,
  className,
}) => {
  if (!data || data.length === 0) return null;

  return (
    <ChartContainer
      config={{
        value: { color: "var(--accent-primary)" },
      }}
      className={clsx(
        "w-full h-full overflow-hidden flex items-center justify-center",
        className,
      )}
    >
      <RadarChart
        data={data}
        outerRadius="60%"
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        <ChartTooltip
          cursor={false}
          content={
            <ChartTooltipContent
              formatter={(value) =>
                minFixedDecimal(value as number, DP22) + "%"
              }
            />
          }
        />

        <PolarAngleAxis
          dataKey="name"
          tick={{
            fontSize: 10,
          }}
        />

        <PolarGrid />

        <Radar
          dataKey="value"
          fill="var(--color-value)"
          stroke="var(--color-value)"
          fillOpacity={0.5}
        />
      </RadarChart>
    </ChartContainer>
  );
};

export default ProfileRadarChart;
